import { useFeatureFlag } from 'v2/core/clients/featureFlag';
import { FeatureFlagType } from 'v2/core/clients/featureFlag/flags';

const featureFlag: FeatureFlagType = {
  name: 'create-custom-group',
  fallback: false,
};

export const useIsCreateCustomGroupsEnabled = () => {
  const [, isEnabled] = useFeatureFlag(featureFlag);

  return isEnabled;
};
